import { render } from "./Main.vue?vue&type=template&id=2dcbab52"
const script = {}

import exportComponent from "/codebuild/output/src1115173202/src/asistomedia-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__